<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
            name="Add Details"
            bc1="App"
            bc2="Features"
            bc3="Add"
            path="Features"
          ></Breadcrumb>
        </div>
        <div
          class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
          <div class="form-group breadcrumb-right">
            <div class="dropdown">
              <button
                class="btn-icon btn btn-primary btn-round btn-sm dropdown-toggle"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <CommandIcon />
              </button>
              <div class="dropdown-menu dropdown-menu-right">
                <a class="dropdown-item" href="app-todo.html"
                  ><i class="mr-1" data-feather="check-square"></i
                  ><span class="align-middle">Todo</span></a
                ><a class="dropdown-item" href="app-chat.html"
                  ><i class="mr-1" data-feather="message-square"></i
                  ><span class="align-middle">Chat</span></a
                ><a class="dropdown-item" href="app-email.html"
                  ><i class="mr-1" data-feather="mail"></i
                  ><span class="align-middle">Email</span></a
                ><a class="dropdown-item" href="app-calendar.html"
                  ><i class="mr-1" data-feather="calendar"></i
                  ><span class="align-middle">Calendar</span></a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <!-- Basic Horizontal form layout section start -->
        <section id="basic-horizontal-layouts">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Add Details</h4>
                </div>
                <div class="card-body">
                  <form class="form form-horizontal">
                    <div class="row">
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Name</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text"
                                  ><i class="far fa-user"></i
                                ></span>
                              </div>
                              <input
                                type="text"
                                v-model="name"
                                id="name-icon"
                                class="form-control"
                                :class="
                                  errorBag.has('name') ? 'is-invalid' : ''
                                "
                                name="name"
                                placeholder="Name"
                                v-validate="'required'"
                              />
                              <small
                                v-show="errorBag.has('name')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("name") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Type</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <b-form-select
                                v-model="type"
                                size="sm"
                                name="type"
                                v-validate="'required'"
                                class="mt-1"
                                :class="
                                  errorBag.has('type') ? 'is-invalid' : ''
                                "
                              >
                                <b-form-select-option value=""
                                  >Please Select Type
                                </b-form-select-option>
                                <b-form-select-option
                                  v-for="(item, index) in options"
                                  :value="item.id"
                                  :key="index"
                                  >{{ item.text }}
                                </b-form-select-option>
                              </b-form-select>
                              <small
                                v-show="errorBag.has('type')"
                                class="invalid-feedback"
                                >{{ "*" + errorBag.first("type") }}</small
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label>Icon</label>
                          </div>
                          <div class="col-sm-9">
                            <div class="input-group">
                              <div class="custom-file">
                                <small
                                  v-show="errorBag.has('file')"
                                  class="invalid-feedback"
                                  >{{ "*" + errorBag.first("file") }}</small
                                >
                                <input
                                  type="file"
                                  class="custom-file-input"
                                  :class="
                                    errorBag.has('file') ? 'is-invalid' : ''
                                  "
                                  id="customFile1"
                                  name="file"
                                  @change="onFileChanged"
                                  v-validate="'required'"
                                />
                                <label
                                  class="custom-file-label"
                                  for="customFile1"
                                  >{{
                                    icon ? icon.name: "Choose icon image"
                                  }}</label
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="form-group row">
                          <div class="col-sm-3 col-form-label">
                            <label for="name-icon">Is Default</label>
                          </div>
                          <div class="col-sm-9">
                            <input
                              class="custom-checkbox"
                              type="checkbox"
                              v-model="isDefault"
                              :true-value="0"
                              :false-value="1"
                              name="isRequiredCheckbox"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="col-sm-9 offset-sm-3 text-right d-flex">
                        <button
                          type="button"
                          class="btn btn-primary mr-1 d-flex"
                          @click="sendCall"
                          :disabled="loading"
                        >
                          <Loader :loading="loading" :size="size"></Loader>
                          Submit
                        </button>
                        <button
                          type="button"
                          class="btn btn-gradient-secondary"
                          @click="$router.push({ name: 'features' })"
                        >
                          Back
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!-- Basic Horizontal form layout section end -->
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import { CommandIcon } from "vue-feather-icons";

export default {
  components: {
    CommandIcon
  },
  mounted() {},
  data() {
    return {
      name: "",
      type: "",
      parentId: "",
      loading: false,
      size: "10px",
      icon: null,
      isDefault: 0,
      options: [
        { id: 1, text: "Admin" },
        { id: 2, text: "User" },
        { id: 3, text: "Merchant" }
      ]
    };
  },
  computed: {},
  methods: {
    onFileChanged(event) {
      this.icon = event.target.files[0];
    },
    sendCall() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.loading = true;

          var data = {
            name: this.name,
            type: this.type,
            parentId: this.isDefault,
          }

          let attachment = new FormData();
          attachment.append("icon", this.icon);
          data.hasAttachment = attachment


          this.makeRequest("post", "v1/add-feature", data).then(
            callResponse => {
              if (!callResponse.error) {
                let code = callResponse.response.data.code;
                if (code == 200) {
                  this.loading = false;
                  this.$router.push({
                    name: "role",
                    params: { add: true }
                  });
                  if (callResponse.response.data.data) {
                    let responseData = callResponse.response.data.data;
                    let storeData = this.$store.getters.getByKey("features");
                    if (typeof storeData.firstPageData != "undefined") {
                      storeData.firstPageData.data.unshift(responseData);
                      storeData.firstPageData.data.pop();
                      storeData.key = "features";
                      delete storeData.otherPageData;
                      this.$store.dispatch("set", storeData);
                    }
                    this.$router.push({
                      name: "features",
                      params: { add: true }
                    });
                  }
                } else if (code == 400) {
                  this.loading = false;
                }
              }
            }
          );
        }
      });
    }
  }
};
</script>

